export const dataConstants = {
    SET_VAL: 'SET_VAL'
}
